// extracted by css-extract-rspack-plugin
export default {"input":"LabeledInputWithUnit_input__1H8Qp"};